export default class GetNewsAcknowledgmentsRequest {
    public newsId: string = "";
    public pageNumber: number = 1;
    public pageSize: number = 10;
}
